import React, { Fragment } from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function ManageCoupons() {
  const navigate = useNavigate();
  const coupons = [{
    id: 2006,
    code: '2006',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2007,
    code: '2007',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2008,
    code: '2008',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2009,
    code: '2009',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '06/01/2024',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2013,
    code: '2013',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: 'Not set',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2014,
    code: '2014',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2015,
    code: '2015',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2018,
    code: '2018',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '06/01/2024',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2019,
    code: '2019',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2021,
    code: '2021',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/11/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2022,
    code: '2022',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/12/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2023,
    code: '2023',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2024,
    code: '2024',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2025,
    code: '2025',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2029,
    code: '2029',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2031,
    code: '2031',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2033,
    code: '2033',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2034,
    code: '2034',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2037,
    code: '2037',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2039,
    code: '2039',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2040,
    code: '2040',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '05/21/2014',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2041,
    code: '2041',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '11/19/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2042,
    code: '2042',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '11/19/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2043,
    code: '2043',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '10/03/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2044,
    code: '2044',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '09/18/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2458,
    code: '2458',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '06/24/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2460,
    code: '2460',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '06/24/2020',
    limitations: 'Single',
    exceed: 'no'
  }, {
    id: 2462,
    code: '2462',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '05/14/2020',
    limitations: 'All',
    exceed: 'no'
  }, {
    id: 2463,
    code: '2463',
    type: 'Dollar',
    usage: 'Per customer',
    amount: '19.95',
    expire: '05/14/2020',
    limitations: 'All',
    exceed: 'no'
  }];
  return <div className="space-y-4" data-id="element-1095">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1096">Manage Coupons</h1>

      {/* Filters */}
      <div className="flex flex-wrap items-end gap-3" data-id="element-1097">
        <div data-id="element-1098">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1099">Code</label>
          <input type="text" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-28" data-id="element-1100" />
        </div>
        <div data-id="element-1101">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1102">
            Discount Type
          </label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-28" data-id="element-1103">
            <option data-id="element-1104">All Types</option>
            <option data-id="element-1105">Percentage</option>
            <option data-id="element-1106">Dollar</option>
          </select>
        </div>
        <div data-id="element-1107">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1108">
            Usage Type
          </label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-32" data-id="element-1109">
            <option data-id="element-1110">All Usages</option>
            <option data-id="element-1111">General Use</option>
            <option data-id="element-1112">Per Customer</option>
          </select>
        </div>
        <div data-id="element-1113">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1114">
            Limitations
          </label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-28" data-id="element-1115">
            <option data-id="element-1116">All</option>
            <option data-id="element-1117">Single</option>
          </select>
        </div>
        <div data-id="element-1118">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1119">
            Exceed Amount
          </label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-20" data-id="element-1120">
            <option data-id="element-1121">Any</option>
            <option data-id="element-1122">Yes</option>
            <option data-id="element-1123">No</option>
          </select>
        </div>
        <div data-id="element-1124">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1125">Group</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-24" data-id="element-1126">
            <option data-id="element-1127">All Groups</option>
            <option data-id="element-1128">PAR</option>
            <option data-id="element-1129">SAAR</option>
          </select>
        </div>
        <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1130">
          Search
        </Button>
        <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/coupons/add')} data-id="element-1131">
          <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-1132" />
          Add
        </Button>
        <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1133">
          <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-1134" />
          Add PAR Coupon
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1135">
        <div className="overflow-x-auto" data-id="element-1136">
          <table className="w-full text-sm text-left" data-id="element-1137">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1138">
              <tr data-id="element-1139">
                <th className="px-3 py-3 border-r border-slate-700 w-8" data-id="element-1140">
                  <input type="checkbox" className="rounded border-slate-500" data-id="element-1141" />
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-20" data-id="element-1142">
                  Coupon Code
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-20" data-id="element-1143">
                  Discount Type
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-28" data-id="element-1144">
                  Usage Type
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1145">
                  Discount Amount
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-1146">
                  Expire Date
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1147">
                  Limitations
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1148">
                  Exceed Amount
                </th>
                <th className="px-3 py-3 text-center w-32" data-id="element-1149">
                  <div data-id="element-1150">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1151">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1152">
              {coupons.map(coupon => <tr key={coupon.id} className="hover:bg-slate-50" data-id="element-1153">
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1154">
                    <input type="checkbox" className="rounded border-slate-300" data-id="element-1155" />
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1156">
                    {coupon.code}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1157">
                    {coupon.type}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200" data-id="element-1158">
                    {coupon.usage}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1159">
                    {coupon.amount}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1160">
                    {coupon.expire}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1161">
                    {coupon.limitations}
                  </td>
                  <td className="px-3 py-2 border-r border-slate-200 text-center" data-id="element-1162">
                    {coupon.exceed}
                  </td>
                  <td className="px-3 py-2 text-center" data-id="element-1163">
                    <div className="flex items-center justify-center gap-2" data-id="element-1164">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/coupons/view/${coupon.id}`)} data-id="element-1165">
                        <Eye className="h-4 w-4" data-id="element-1166" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/coupons/edit/${coupon.id}`)} data-id="element-1167">
                        <Edit className="h-4 w-4" data-id="element-1168" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1169">
                        <Trash2 className="h-4 w-4" data-id="element-1170" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="flex items-center justify-between" data-id="element-1171">
        <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1172">
          Delete Selected
        </Button>
        <div className="text-sm text-blue-600 flex items-center gap-1" data-id="element-1173">
          <button className="hover:underline" data-id="element-1174">&lt;&lt; previous</button>
          <span className="text-slate-400" data-id="element-1175">|</span>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n, i) => <Fragment key={n} data-id="element-1176">
              {i > 0 && <span className="text-slate-400" data-id="element-1177">|</span>}
              <button className={`hover:underline ${n === 1 ? 'text-slate-900 font-medium' : ''}`} data-id="element-1178">
                {n}
              </button>
            </Fragment>)}
          <span className="text-slate-400" data-id="element-1179">|</span>
          <button className="hover:underline" data-id="element-1180">next &gt;&gt;</button>
        </div>
      </div>
    </div>;
}